import React from 'react'
import { GenericGraph } from '../../utils/GenericGraph'

const Rating = (props) => {
    var res = props.data['res']
    var temp = {}

    for (var rr in res){

        if(res[rr] in temp)
        {
            temp[res[rr]]+=1;
        }
        else
        {
            temp[res[rr]]=1;
        }
    }

    var dp = []
    for(var k in temp)
    {
        dp.push({'y':temp[k],'label':k})
    }

    const options = {
        exportEnabled: true,
        animationEnabled: true,
        title: {
            text: props.data.name,
        },
        data: [{
            type: "column",
            showInLegend: "true",
            legendText: "{label}",
            indexLabelFontSize: 16,
            indexLabel: "{label} - {y}%",
            dataPoints:dp
        }]
    }

  return (
    <div style={{boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
        padding: "5%",margin: "5% 2%",width:"45%"}}>
            <div className='graphs'><GenericGraph options={options} /></div>
        </div>
  )
}

export default Rating
